module.exports = __webpack_public_path__ + "static/img/5-3.f37ec36.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/5-3.png
// module id = 274
// module chunks = 0